import React from 'react';
import ReactDOM from 'react-dom';
import './static/css/general/reset.scss';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import ReduxThunk from 'redux-thunk'
import reducers from './reducers';

window.devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

const store = createStore(reducers, compose(applyMiddleware(ReduxThunk), window.devToolsExtension ? window.devToolsExtension() : f => f));

ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById('root'));
registerServiceWorker();
